var _rect, _circle, _circle2, _ellipse, _path, _path2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalRegions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#6366F1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 17.5,
    cy: 18.5,
    r: 2.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 26.5,
    cy: 18.5,
    r: 2.5,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 22,
    cy: 26,
    rx: 6,
    ry: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4948 27.9874C27.4316 27.4582 28.0002 26.7623 28.0002 26C28.0002 24.813 26.6215 23.7871 24.6211 23.3006C25.3286 23.1089 26.1389 23 27.0002 23C29.7616 23 32.0002 24.1193 32.0002 25.5C32.0002 26.8807 29.7616 28 27.0002 28C26.8296 28 26.661 27.9957 26.4948 27.9874Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5053 27.9874C17.3392 27.9957 17.1706 28 17 28C14.2386 28 12 26.8807 12 25.5C12 24.1193 14.2386 23 17 23C17.8612 23 18.6716 23.1089 19.3791 23.3006C17.3787 23.7871 16 24.813 16 26C16 26.7623 16.5686 27.4582 17.5053 27.9874Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18,
    r: 3,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRegions);
export default __webpack_public_path__ + "static/media/total-regions.f8e39ecea971dca7595f3d4e442c4b97.svg";
export { ForwardRef as ReactComponent };